import { Fragment, useEffect, useRef, useState } from "react";
import { PAGES } from "../../../routeConfig";
import { useNoteAlert } from "../../../Context/pleaseNote";
import { BreadCrumb } from "../../../Layout/Common/breadCrumb";
import { cardMonthYear, isNumeric, isValidArray, validateMonthYear } from "../../../Layout/Common/common";
import { axiosInstance } from "../../../axios/axiosInstance";
import { useAuth } from "../../../Context/AuthContext";
import { SaveCardPaymentGatewayWindow } from "./saveCardPaymentGatewayWindow";
import { Link, useNavigate, useParams } from "react-router-dom";
import { cardValidationError, getTillBrowserData } from "../../../constants";
import { CancelButton } from "../../../Layout/Common/cancelButton";
import $ from "jquery";
import { CardIcon } from "../../../Layout/Common/CardIcon";

var Textstyle = {
  display: "block",
  width: "99.5%",
  height: "56px",
  padding: ".375rem .75rem",
  fontSize: "1rem",
  lineheight: "1.5",
  color: "#212529",
  backgroundcolor: "#ffffff",
  backgroundimage: "none",
  backgroundClip: "padding-box",
  border: "none",
  borderRadius: "0.375rem",
  transition: "border-color .15s ease-in-out,box-shadow .15s ease-in-out",
  appearance: "none",
  marginLeft: "1px",
  paddingTop: "22px",
};
export const MyWalletNewCard = () => {
  const [newcardName, setNewcardName] = useState("");
  const [cardNumber, setCardNumber] = useState("");
  const [cardCVV, setCardCVV] = useState("");
  const [newcardExp, setNewcardExp] = useState("");
  const [tillToken, setTillToken] = useState("");
  const [tillUrl, setTillUrl] = useState("");
  const containerRef = useRef(null);
  const { userId } = useAuth();
  const { transId } = useParams();
  const { showNoteAlert, showModelAlert, showFlashScreen, hideNoteAlert } = useNoteAlert();
  const [DefaultValue, setDefaultValue] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
  }, [transId]);

  useEffect(() => {
    initcard();
  }, []);


  const GenerateToken = () => {
    try {
      var validation = true;
      var cardName = newcardName;
      var cardExp = newcardExp;
      // Pass messages, not `true`: flashScreen.js only renders the spinner when
      // flashMessages is non-empty, so showFlashScreen(true) shows a bare panel.
      showFlashScreen({
        messages: ["Verifying your card, please wait…", "Please do not refresh or close this window."],
      });
      if (newcardName == "") {
        showNoteAlert("Please Enter Card Name", "Please Note", true, () => {
          $("#form_cardHolder").focus();
        });
        return false;
      } else if (isNumeric(cardName) === false) {
        showFlashScreen(false);
        validation = false;
        showModelAlert({
          title: cardValidationError["cardHolder"].title,
          content: cardValidationError["cardHolder"].content,
          icon: "wes-invalid-card",
        });
        return false;
      }
      var isv = 1;
      if (cardExp == "") {
        showNoteAlert("Please Enter Card Expiry Date", "Please Note", true, () => {
          $("#walletExpiryDate").focus();
        });
        return false;
      } else if (!validateMonthYear(cardExp)) {
        isv = 0;
        showFlashScreen(false);
        validation = false;
        showModelAlert({
          title: cardValidationError["expiryDate"].title,
          content: cardValidationError["expiryDate"].content,
          icon: "wes-invalid-card",
        });
        return false;
      }
      if (validation) {
        var splitval = cardExp.split("/");
        var data = {
          card_holder: cardName,
          month: splitval[0],
          year: splitval[1],
        };
        window.till.tokenize(
          data,
          function (token, cardData) {
            var isdefault = "0";
            setTillToken(token);
            ProcessPayment(token);
          },
          function (errors) {
            if (errors) {
              if (isValidArray(errors)) {
                var errmsg = errors[0];
                if (errmsg) {
                  if (errmsg.attribute == "number") {
                    if (errmsg.message == "Card number must not be empty") {
                      showNoteAlert("Please Enter Card Number", "Please Note", true, () => {
                        $("#card_Number").focus();
                      });
                    } else {
                      showModelAlert({
                        title: cardValidationError["number"].title,
                        content: cardValidationError["number"].content,
                        icon: "wes-invalid-card",
                      });
                    }
                  } else if (errmsg.attribute == "cvv") {
                    if (errmsg.message == "CVV code must not be empty") {
                      showNoteAlert("Please Enter CVV", "Please Note", true, () => {
                        $("#card_Cvv").focus();
                      });
                    } else {
                      showModelAlert({
                        title: cardValidationError["cvv"].title,
                        content: cardValidationError["cvv"].content,
                        icon: "wes-invalid-card",
                      });
                    }
                  } else
                    showModelAlert({
                      title: cardValidationError["default"].title,
                      content: cardValidationError["default"].content,
                      icon: "wes-invalid-card",
                    });
                } else {
                  showModelAlert({
                    title: cardValidationError["default"].title,
                    content: cardValidationError["default"].content,
                    icon: "wes-invalid-card",
                  });
                }
              }
            }

            showFlashScreen(false);
          },
        );
      } else {
        showModelAlert({
          title: cardValidationError["default"].title,
          content: cardValidationError["default"].content,
          icon: "wes-invalid-card",
        });
        showFlashScreen(false);
      }
    } catch (e) {
    }
  };

  const ProcessPayment = (trntoken) => {
    var params = {
      userId: String(userId),
      transToken: trntoken,
      successUrl: PAGES.MYWALLET,
      is_default: String(DefaultValue),
      browserData: getTillBrowserData(),
    };

    axiosInstance
      .post("MyWallet/Save", params)
      .then((response) => {
        if (response && response.data) {
          // window.location.ref = response.data.RedirectTo;
          if (response.data.Message == "Card Already Exist") {
            showFlashScreen(false);
            showNoteAlert("Card Already Exist", "Please Note", true, () => {
              $("#card_Number").focus();
            });
          } else {
            showFlashScreen(false);
            setTillUrl(response.data.RedirectTo);
          }
        }
      })
      .catch((error) => {
        showNoteAlert("Something wroung. try again.");
        showFlashScreen(false);
      });
  };
  const initcard = () => {
    window.till = new window.PaymentJs();
    window.till.init(process.env.REACT_APP_TILL, "card_Number", "card_Cvv", function (p) {
      p.setNumberStyle(Textstyle);
      p.setCvvStyle(Textstyle);
    });
  };
  // Clear the gateway URL so a retry re-opens the verification window.
  const paymentDeclineFunction = () => {
    setTillUrl("");
  };

  const handleCardnumberType = (e) => {
    try {
      const input = containerRef.current.querySelector('input[name="card_number"]');
      if (input) {
        input.value = e.target.value;
      }
    } catch (e) {
      console.error("myWalletNewCard.jsx", e);
    }
  };
  return (
    <Fragment>
      <BreadCrumb
        data={[
          { name: "My Account", url: "/myaccount" },
          { name: "My Wallet", url: PAGES.MYWALLET },
          { name: "Add New Card", url: PAGES.MYWALLETADD },
        ]}
      />
      <SaveCardPaymentGatewayWindow url={tillUrl} isDefault={DefaultValue} callback={paymentDeclineFunction} />
      <section className="myAccount-section">
        <div className="container-fluid container-lg">
          <div className="row">
            <div className="col-lg-12">
              <div className="acc-header py-3">
                <div className="myaccount-address myAccount-header-inner">
                  <h1 className="myaccount-title">Add New Card</h1>
                  <div className="order-invoice myFavoriteList">
                    <p>Fill Below Details to Save New Card in your list</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-4">
            {/* Add New Card */}
            <div className="col-sm-8 col-lg-6">
              {/* From */}
              <form>
                <div className="row">
                  <div className="col-12 col-lg-12">
                    <div className="floating-input mb-3">
                      <input
                        id="form_cardHolder"
                        className="form-control form-input"
                        type="text"
                        placeholder=""
                        onChange={(e) => {
                          const cleaned = e.target.value.replace(/[^a-z0-9 ]/gi, "");
                          setNewcardName(cleaned);
                        }}
                        value={newcardName}
                        required=""
                      />
                      <label htmlFor="form_cardHolder">Card Holder Name</label>
                    </div>
                  </div>
                  <div className="col-12 col-lg-12">
                    <div className="floating-input   addWalletCard" style={{ height: 75 }}>
                      <input
                        className="form-control form-input"
                        id="walletCardNumber"
                        name="walletCardNumber"
                        maxLength={19}
                        placeholder=""
                        inputMode="numeric"
                        autoComplete="off"
                        required=""
                        disabled
                        onChange={handleCardnumberType}
                      />
                      <div
                        id="card_Number"
                        className="card-no-info"
                        style={{ height: "61px", padding: 0, top: "-57px" }}
                      ></div>
                      <label htmlFor="walletCardNumber" style={{ top: "8px", fontSize: "12px" }}>
                        Card Number
                      </label>
                      <CardIcon cardType="cards" alt="Card" />
                    </div>
                  </div>
                  <div className="col-6 col-lg-6">
                    <div className="floating-input placeHolderInput mb-3">
                      <input
                        type="text"
                        id="walletExpiryDate"
                        className="form-control form-input"
                        maxLength={5}
                        placeholder="MM/YY"
                        inputMode="numeric"
                        value={newcardExp}
                        onChange={(e) => {
                          let val = cardMonthYear(e.target.value);
                          setNewcardExp(val);
                        }}
                      />
                      <label htmlFor="walletExpiryDate">Expiry Date (MM/YY)</label>
                    </div>
                  </div>
                  <div className="col-6 col-lg-6">
                    <div className="floating-input placeHolderInput mb-3" style={{ height: 75 }}>
                      <label htmlFor="cardCvv">CVV</label>
                      <input
                        type="text"
                        id="cardCvv"
                        name="cardCvv"
                        maxLength={3}
                        pattern="\d{3}"
                        placeholder={123}
                        className="form-control form-input"
                        inputMode="numeric"
                        required=""
                        disabled
                      />
                      <div
                        id="card_Cvv"
                        className="card-no-info"
                        style={{
                          height: "61px",
                          padding: 0,
                          top: "-57px",
                          width: "99.5%",
                        }}
                      ></div>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div>
                      <div className="form-check custom-check">
                        <div className="signature-req-input">
                          <input
                            type="checkbox"
                            name="DefaultValue"
                            id="DefaultValue"
                            className="form-check-input"
                            checked={DefaultValue}
                            onChange={(e) => {
                              setDefaultValue(!DefaultValue);
                            }}
                          />
                          <label
                            className="form-check-label col-fs-13 fs-14 fw-normal"
                            htmlFor="DefaultValue"
                            style={{ paddingLeft: "5px" }}
                          >
                            Set as Default
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="saveAddress-btn">
                      <div className="button-effect">
                        <button type="button" className="btn btn-products btn-addcart" onClick={GenerateToken}>
                          Save Card
                        </button>
                      </div>
                      <CancelButton
                        onClick={() => {
                          navigate(PAGES.MYACCOUNT);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </form>

              {/* From */}
            </div>
            {/* Add New Card */}
          </div>
        </div>
      </section>
      <div
        ref={containerRef}
        id="card_Number"
        className="mb-3 card-no-info"
        style={{ height: "44px", padding: 0 }}
      ></div>
    </Fragment>
  );
};
